import React from "react";
import { Spinner } from "react-bootstrap";
import "../Pages/Company/Company.css";

/**
 * Proper page/section loader.
 * Pass rsa=true for RSA Pakistan branded loader (logo + orange spinner).
 */
const AppLoader = ({
  rsa = false,
  overlay = false,
  message,
  compact = false,
}) => {
  const text =
    message ||
    (rsa ? "Loading RSA data..." : "Loading...");

  const content = (
    <div
      className={`app-loader${rsa ? " app-loader--rsa" : ""}${
        compact ? " app-loader--compact" : ""
      }`}
    >
      {rsa ? (
        <div className="app-loader-brand">
          <img
            src="/RSA_Pakistan_Logo.png"
            alt="RSA Pakistan"
            className="app-loader-logo"
          />
          <div className="app-loader-ring" aria-hidden="true" />
        </div>
      ) : (
        <Spinner
          animation="border"
          variant="primary"
          style={{ width: compact ? "1.75rem" : "2.5rem", height: compact ? "1.75rem" : "2.5rem" }}
        />
      )}
      <p className="app-loader-text mb-0">{text}</p>
    </div>
  );

  if (overlay) {
    return (
      <div className={`app-loader-overlay${rsa ? " app-loader-overlay--rsa" : ""}`}>
        {content}
      </div>
    );
  }

  return content;
};

export default AppLoader;
